var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 1.83333H8.31467C8.21156 1.83402 8.10965 1.81122 8.01667 1.76667L5.91267 0.710667C5.63493 0.572363 5.32893 0.500258 5.01867 0.5H3.33333C2.4496 0.501059 1.60237 0.852588 0.97748 1.47748C0.352588 2.10237 0.00105857 2.94961 0 3.83334L0 11.8333C0.00105857 12.7171 0.352588 13.5643 0.97748 14.1892C1.60237 14.8141 2.4496 15.1656 3.33333 15.1667H12.6667C13.5504 15.1656 14.3976 14.8141 15.0225 14.1892C15.6474 13.5643 15.9989 12.7171 16 11.8333V5.16667C15.9989 4.28294 15.6474 3.43571 15.0225 2.81082C14.3976 2.18592 13.5504 1.83439 12.6667 1.83333ZM3.33333 1.83333H5.01867C5.12177 1.83265 5.22368 1.85545 5.31667 1.9L7.42067 2.95267C7.69813 3.09213 8.00413 3.16538 8.31467 3.16667H12.6667C13.0654 3.16732 13.4548 3.28712 13.7849 3.51068C14.115 3.73424 14.3708 4.05136 14.5193 4.42134L1.33333 4.496V3.83334C1.33333 3.3029 1.54405 2.7942 1.91912 2.41912C2.29419 2.04405 2.8029 1.83333 3.33333 1.83333ZM12.6667 13.8333H3.33333C2.8029 13.8333 2.29419 13.6226 1.91912 13.2476C1.54405 12.8725 1.33333 12.3638 1.33333 11.8333V5.82934L14.6667 5.75401V11.8333C14.6667 12.3638 14.456 12.8725 14.0809 13.2476C13.7058 13.6226 13.1971 13.8333 12.6667 13.8333Z",
    fill: "#245372"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.3a34619ec78d44a6040efaf0a9f8a643.svg";
export { ForwardRef as ReactComponent };